import { SUPABASE_PUBLISHABLE_KEY, SUPABASE_URL } from '../supabase/config.js';

// Atividade no projeto mesmo sem sessão: é o que a política anon do heartbeat
// existe para permitir. Nunca lança — abrir o app não pode depender disto.
export async function baterHeartbeat(
  fetchImpl: typeof fetch = fetch,
): Promise<boolean> {
  try {
    const r = await fetchImpl(`${SUPABASE_URL}/rest/v1/heartbeat?select=id`, {
      headers: {
        apikey: SUPABASE_PUBLISHABLE_KEY,
        Authorization: `Bearer ${SUPABASE_PUBLISHABLE_KEY}`,
      },
    });
    return r.ok;
  } catch {
    return false;
  }
}
